import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { useAtom } from 'jotai';

import { Button as ButtonV2, Heading } from '@restworld/ui-ds-base';

import { selectedJobApplicationAtom } from '../../../employer-job-listing.atoms';

import { cn } from '@restworld/utils-common';
function CandidateStateUpdateSuccess({ onClose }: { onClose: () => void; isDiscarded?: boolean }) {
  const { t } = useTranslation('job-positions-page');
  const [selectedJobApplication] = useAtom(selectedJobApplicationAtom);
  const candidateName = selectedJobApplication?.worker?.name ?? '';

  return (
    <Wrapper>
      <NoSymbolIcon className="h-6 w-6 text-red-700 inline-block mx-auto" />
      <Heading color="neutral" className="text-base lg:text-lg">
        {t('you_discarded_name', { name: candidateName })}
      </Heading>
      <ContentWrapper>{t('we_will_send_candidate_email_explaining_reasons')}</ContentWrapper>
      <ButtonV2 onClick={() => onClose()}>{t('close')}</ButtonV2>
    </Wrapper>
  );
}
export default CandidateStateUpdateSuccess;

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'h-full w-full max-w-[650px] mx-auto flex flex-col justify-center items-center gap-5 text-center',
      className
    )}
    {...props}
  />
);
const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-neutral-200 font-medium max-w-[620px]', className)} {...props} />
);
